import React from 'react'
import ReactDOM from 'react-dom'
import ReactTestUtils from 'react-dom/test-utils';
import PropTypes from 'prop-types'
import { Link, NavLink } from 'react-router-dom'

export default class NavClients extends React.Component {

  constructor() {
  super();
  this.simulatePrevArrow = this.simulatePrevArrow.bind(this);
  this.simulateNextArrow = this.simulateNextArrow.bind(this);
}


  simulatePrevArrow() {
      console.log('prev');
}

  simulateNextArrow(e) {
    e.preventDefault();
    console.log('next');
  }


  render() {
    return (
      <nav>
        <section className="container">
          <aside className="page-title">
            <Link to="/">Sergi Miral</Link>
          </aside>
          <aside className="link-border">
            {/* <Link to="/">←</Link>
            <Link to="/">→</Link> */}
            {/* <span>
              <a onClick={this.simulatePrevArrow}>←</a>
              <a onClick={this.simulateNextArrow}>→</a>
            </span> */}
          </aside>
        </section>
      </nav>

    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/components/NavClients.js